import Select from "react-select";
import Card from "../../../../components/layouts/Card";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import { InputWrapper, SelectStyle } from "../../../../components/forms/FormComponents";
import { clearError, fieldErrorMessage, fieldHasErrors } from "../../../../helpers/errorHandler";
import { setBooking, setError, setFormExtension } from "../../../../redux/reducers/bookings/actions";
import { Option, OptionsTime } from "../../../../interfaces/Options";
import { useState } from "react";

const BookingCreateActivity = () => {
  const dispatch = useDispatch();
  const errors = useSelector((state: RootState) => state.booking.error);
  const isLoading = useSelector((state: RootState) => state.booking.isLoading);
  const booking = useSelector((state: RootState) => state.booking.updatedBooking);
  const formExtension = useSelector((state: RootState) => state.booking.formExtension);

  const onChangeEstimateParticipant = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    clearError('estimate_participant', errors, setError, dispatch);
    const val = parseInt(e.target.value);
    dispatch(setBooking({
      ...booking,
      estimate_participant: val
    }));
  };

  const onChangeStartTime = (e: Option | null) => {
    dispatch(setFormExtension({
      ...formExtension,
      start_time: e
    }));
  };

  const onChangeEndTime = (e: Option | null) => {
    dispatch(setFormExtension({
      ...formExtension,
      end_time: e
    }));
  };

  const onChangeStartDate = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    clearError('start_date', errors, setError, dispatch);
    dispatch(setBooking({
      ...booking,
      start_date: e.target.value
    }));
  };

  const onChangeNotes = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    clearError('notes', errors, setError, dispatch);
    dispatch(setBooking({
      ...booking,
      notes: e.target.value
    }));
  };

  const onChangePic = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    clearError('id_user', errors, setError, dispatch);
    const val = parseInt(e.target.value);
    dispatch(setBooking({
      ...booking,
      id_user: val
    }));
  };

  const onChangeDescription = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!booking) return;
    clearError('issuer_name', errors, setError, dispatch);
    dispatch(setBooking({
      ...booking,
      description: e.target.value
    }));
  };

  if (!booking) {
    return <div />
  }

  return (
    <Card>
      <div className="card--title">
        <h2 className="card--title-title">Data Kegiatan</h2>
        <p className="card--title-description">Informasi kegiatan yang akan dilaksanakan</p>
      </div>
      <div className="card--body">
        <InputWrapper disabled={isLoading} hasErrors={fieldHasErrors('description', errors)}>
          <div className="input--field">
            <label>Nama Kegiatan</label>
            <input
              type="text"
              disabled={isLoading}
              value={booking.description}
              onChange={onChangeDescription}
              placeholder="Masukkan nama kegiatan disini"
            />
          </div>
          <div className="input--errors">
            { fieldErrorMessage('description', errors) }
          </div>
        </InputWrapper>
        <InputWrapper disabled={isLoading} hasErrors={fieldHasErrors('estimate_participant', errors)}>
          <div className="input--field">
            <label>Estimasi Jumlah Peserta</label>
            <input
              type="text"
              disabled={isLoading}
              value={booking.estimate_participant}
              onChange={onChangeEstimateParticipant}
              placeholder="Masukkan estimasi jumlah pemakai disini"
            />
          </div>
          <div className="input--errors">
            { fieldErrorMessage('estimate_participant', errors) }
          </div>
        </InputWrapper>
        <InputWrapper disabled={isLoading} hasErrors={fieldHasErrors('start_date', errors)}>
          <div className="input--field">
            <label>Tanggal Peminjaman</label>
            <input
              type="date"
              disabled={isLoading}
              value={booking.start_date}
              onChange={onChangeStartDate}
              placeholder="Masukkan tanggal peminjaman disini"
            />
          </div>
          <div className="input--errors">
            { fieldErrorMessage('start_date', errors) }
          </div>
        </InputWrapper>
        <InputWrapper disabled={isLoading} hasErrors={fieldHasErrors('start_date_time', errors)}>
          <div className="input--field select">
            <label>Jam Mulai Peminjaman</label>
            <Select
              styles={SelectStyle}
              isDisabled={isLoading}
              value={formExtension.start_time}
              options={OptionsTime}
              onChange={(e: any) => onChangeStartTime(e)}
              menuPortalTarget={document.querySelector("body")}
            />
          </div>
          <div className="input--errors">
            { fieldErrorMessage('start_date_time', errors) }
          </div>
        </InputWrapper>
        <InputWrapper disabled={isLoading} hasErrors={fieldHasErrors('end_date_time', errors)}>
          <div className="input--field select">
            <label>Jam Selesai Peminjaman</label>
            <Select
              styles={SelectStyle}
              isDisabled={isLoading}
              value={formExtension.end_time}
              options={OptionsTime}
              onChange={(e: any) => onChangeEndTime(e)}
              menuPortalTarget={document.querySelector("body")}
            />
          </div>
          <div className="input--errors">
            { fieldErrorMessage('end_date_time', errors) }
          </div>
        </InputWrapper>
        <InputWrapper disabled={isLoading} hasErrors={fieldHasErrors('notes', errors)}>
          <div className="input--field">
            <label>Catatan Tambahan</label>
            <input
              type="text"
              disabled={isLoading}
              value={booking.notes}
              onChange={onChangeNotes}
              placeholder="Masukkan catatan inventaris disini"
            />
          </div>
          <div className="input--errors">
            { fieldErrorMessage('notes', errors) }
          </div>
        </InputWrapper>
      </div>
    </Card>
  )
}

export default BookingCreateActivity;